import React, { useEffect } from "react";
import { Auth } from "aws-amplify";
import { useNavigate, useParams } from "react-router-dom";
import {
  CONSTANTS as SHARED_CONSTANTS,
  CustomerOrigin,
  getQueryStringParams,
} from "@theatticusapp/atticus-shared-components";
import Cookies from "js-cookie";
import { SCREEN_PATHS, STORAGE } from "../../constants";
import { authApi } from "../../apis";

export const Invite = (): JSX.Element => {
  const navigate = useNavigate();
  const { inviteId } = useParams();
  // partner app will set a cookie containing inviteId
  //  https://github.com/TheAtticusApp/atticus-partners/blob/master/src/App.tsx#L38
  const partnerInviteId = Cookies.get(SHARED_CONSTANTS.COOKIES.inviteId);

  if (inviteId) {
    // coming from advisor invite
    console.log("inviteId:", inviteId);
    window.sessionStorage.setItem(STORAGE.invite, inviteId);
  } else if (partnerInviteId) {
    // coming from partners app
    console.log("partnerInviteId:", partnerInviteId);
    window.sessionStorage.setItem(STORAGE.invite, partnerInviteId);
  }

  const params = getQueryStringParams();

  const goToSignUp = () => {
    let path = `${SCREEN_PATHS.auth}?signup=true`;
    // pass all params
    Object.entries(params).map(([key, value]: [key: string, value: any]) => {
      path += key && `&${key}=${value}`;
    });
    navigate(path);
  };

  useEffect(() => {
    // when advisor is creating an account for the user, we need to make sure there isn't a authenticated session
    // if origin=AdvisorWebApp && user is signed in, sign them out, then proceed to signup screen
    (async () => {
      const isAccountCreateByAdvisor =
        params?.origin === CustomerOrigin.AdvisorWebApp;
      if (isAccountCreateByAdvisor) {
        await Auth.currentSession()
          .then(async () => {
            // has an active session, end it to allow account creation
            //  don't clear session storage
            await authApi.signOut(false, true);
            goToSignUp();
          })
          .catch(() => {
            // no session, just go
            goToSignUp();
          });
      } else {
        goToSignUp();
      }
    })();
  }, []);

  return <></>;
};
